import { cn } from "@/libs/cn";

interface SkeletonProps {
  className?: string;
}

const Skeleton = ({ className }: SkeletonProps) => {
  return <div className={cn("animate-pulse rounded bg-gray-200", className)} />;
};

export default Skeleton;
